import { Link } from '@tanstack/react-router';
import { User } from 'iconoir-react';
import { useAuth } from '../../contexts/AuthContext';

export const AccountLink = () => {
  const { currentUser } = useAuth();

  // No outer margin: the header's right-group flex container owns spacing via
  // `gap` (CU-86ajd3yt0 header responsive fix). A local ml-4 would double it.
  return (
    <button style={{ cursor: 'pointer' }} aria-label="Profile">
      <Link to="/$patientId/profile" params={{ patientId: currentUser?.uid ?? '' }}>
        <User height={'2em'} width={'2em'} color="#fff" />
      </Link>
    </button>
  );
};
